export default "__VITE_ASSET__5908a76f__"